import Vue from 'vue';
export default Vue.extend({
    name: 'confirmSecretCodeToResolveNetworksPopupChunk',
    props: {
        slotData: {
            required: true
        }
    },
    data() {
        return {
            form: {
                fields: {
                    secretCode: {
                        valid: false,
                        value: '',
                        type: 'password',
                        rules: [
                            (v) => Boolean(v.length) || this.$t('whitelistsPage.errors.fieldIsRequired')
                        ]
                    }
                }
            }
        };
    },
    methods: {
        toggleSecretAppear() {
            this.form.fields.secretCode.type = this.form.fields.secretCode.type === 'password' ? 'text' : 'password';
        }
    }
});
